/* DailyLama — collection « Bracelets » V2.
 * Les cartes sont rendues par Liquid pour TOUTE la collection ; ce script ne fait
 * que filtrer, trier, dévoiler par lots, ouvrir le choix du diamètre et ajouter
 * au panier par l'API Ajax du thème (même mécanisme que les fiches V3).
 * Aucune dépendance. Tout est porté par [data-dlcb]. */
(function () {
  'use strict';

  var racine = document.querySelector('[data-dlcb]');
  if (!racine) return;

  var cfg;
  try { cfg = JSON.parse(racine.querySelector('[data-dlcb-config]').textContent); } catch (e) { return; }

  var q = function (sel, ctx) { return (ctx || racine).querySelector(sel); };
  var qa = function (sel, ctx) { return [].slice.call((ctx || racine).querySelectorAll(sel)); };

  var grille = q('[data-dlcb-grille]');
  var noeudCompte = q('[data-dlcb-compte]');
  var noeudSuite = q('[data-dlcb-suite]');
  var noeudSuiteCompte = q('[data-dlcb-suite-compte]');
  var boutonSuivants = q('[data-dlcb-suivants]');
  var noeudVide = q('[data-dlcb-vide]');
  var noeudActifs = q('[data-dlcb-actifs]');
  var listeActifs = q('[data-dlcb-actifs-liste]');
  var libelleFiltre = q('[data-dlcb-filtre-libelle]');
  var boutonFiltres = q('[data-dlcb-ouvrir-filtres]');
  var selectTri = q('[data-dlcb-tri]');
  var dialogFiltres = q('[data-dlcb-filtres]');
  var dialogChoix = q('[data-dlcb-choix]');
  var boutonAppliquer = q('[data-dlcb-appliquer]');
  var zoneToast = q('[data-dlcb-toast]');
  var casesFiltre = qa('[data-dlcb-filtre]');
  var boutonsIntention = qa('[data-dlcb-intention]');
  var html = document.documentElement;

  // ------------------------------------------------------------------ données
  var cartes = qa('[data-dlcb-carte]').map(function (el) {
    var variantes = [];
    var brut = q('[data-dlcb-variantes]', el);
    try { variantes = JSON.parse(brut.textContent); } catch (e) { variantes = []; }
    var d = el.dataset;
    var img = q('img', el);
    return {
      el: el,
      ordre: +d.ordre || 0,
      cree: +d.cree || 0,
      nom: d.nom || '',
      url: d.url || '#',
      prixMin: +d.prixMin || 0,
      pierres: (d.pierres || '').split(' ').filter(Boolean),
      intentions: (d.intentions || '').split(' ').filter(Boolean),
      construction: d.construction || 'inconnu',
      dispo: d.dispo === '1',
      mode: d.mode || 'autre',
      pack: d.pack === '1',
      teinte: d.teinte || 'auto',
      img: img ? img.currentSrc || img.src : '',
      imgAlt: img ? img.alt : '',
      variantes: variantes,
      prixEl: q('[data-dlcb-prix]', el),
      prixAffiche: +d.prixMin || 0
    };
  });

  var etat = { intentions: [], pierres: [], construction: [], budget: [], stock: false, tri: 'preferes', visibles: cfg.parPage || 24 };
  var BANDES = {
    b1: [0, cfg.seuilBas - 1],
    b2: [cfg.seuilBas, cfg.seuilHaut],
    b3: [cfg.seuilHaut + 1, Infinity]
  };

  function dansBudget(prix) {
    return etat.budget.some(function (b) { var lim = BANDES[b]; return lim && prix >= lim[0] && prix <= lim[1]; });
  }
  function variantesBudget(c) {
    return c.variantes.filter(function (v) { return v.dispo && dansBudget(v.prix); });
  }

  // Un même groupe se combine par OU, les groupes entre eux par ET. `sauf`
  // ignore un groupe : c'est ce qui donne les compteurs « si je cochais ceci ».
  function correspond(c, sauf) {
    if (sauf !== 'intention' && etat.intentions.length && !c.intentions.some(function (i) { return etat.intentions.indexOf(i) > -1; })) return false;
    if (sauf !== 'pierres' && etat.pierres.length && !c.pierres.some(function (p) { return etat.pierres.indexOf(p) > -1; })) return false;
    if (sauf !== 'construction' && etat.construction.length && etat.construction.indexOf(c.construction) < 0) return false;
    if (sauf !== 'budget' && etat.budget.length && !variantesBudget(c).length) return false;
    if (sauf !== 'stock' && etat.stock && !c.dispo) return false;
    return true;
  }
  function correspondOption(c, groupe, valeur) {
    if (groupe === 'intention') return c.intentions.indexOf(valeur) > -1;
    if (groupe === 'pierres') return c.pierres.indexOf(valeur) > -1;
    if (groupe === 'construction') return c.construction === valeur;
    if (groupe === 'stock') return c.dispo;
    if (groupe === 'budget') {
      var lim = BANDES[valeur];
      return c.variantes.some(function (v) { return v.dispo && v.prix >= lim[0] && v.prix <= lim[1]; });
    }
    return false;
  }
  function compteOption(groupe, valeur) {
    var n = 0;
    cartes.forEach(function (c) { if (correspond(c, groupe) && correspondOption(c, groupe, valeur)) n++; });
    return n;
  }
  function nbActifs() {
    return etat.intentions.length + etat.pierres.length + etat.construction.length + etat.budget.length + (etat.stock ? 1 : 0);
  }
  function pluriel(n, mot) { return n + ' ' + mot + (n > 1 ? 's' : ''); }

  // ------------------------------------------------------------------ prix présenté
  // Sous un filtre budget, la carte montre la variante qui entre dans la
  // tranche, jamais un « Dès … » hors budget.
  function prixPresente(c) {
    if (!etat.budget.length) {
      c.prixAffiche = c.prixMin;
      if (c.prixEl) { c.prixEl.textContent = c.prixEl.getAttribute('data-prix-initial'); c.prixEl.classList.remove('dlcb-carte__prix--budget'); }
      return;
    }
    var vs = variantesBudget(c);
    if (!vs.length) return;
    var mini = vs.reduce(function (a, v) { return v.prix < a.prix ? v : a; });
    var memePrix = vs.every(function (v) { return v.prix === mini.prix; });
    c.prixAffiche = mini.prix;
    var texte;
    if (vs.length === 1) texte = (mini.label ? mini.label + ' — ' : '') + mini.prixTxt;
    else if (memePrix) texte = mini.prixTxt;
    else texte = 'Dès ' + mini.prixTxt;
    if (c.prixEl) { c.prixEl.textContent = texte; c.prixEl.classList.add('dlcb-carte__prix--budget'); }
  }

  // ------------------------------------------------------------------ rendu
  function appliquer(sansUrl) {
    var resultats = cartes.filter(function (c) { return correspond(c); });
    resultats.forEach(prixPresente);

    var tri = etat.tri;
    resultats.sort(function (a, b) {
      if (tri === 'prix-asc') return (a.prixAffiche - b.prixAffiche) || (a.ordre - b.ordre);
      if (tri === 'prix-desc') return (b.prixAffiche - a.prixAffiche) || (a.ordre - b.ordre);
      if (tri === 'nouveautes') return (b.cree - a.cree) || (a.ordre - b.ordre);
      return a.ordre - b.ordre;
    });

    var montrees = 0;
    resultats.forEach(function (c, i) {
      grille.appendChild(c.el);
      var visible = i < etat.visibles;
      c.el.hidden = !visible;
      if (visible) montrees++;
    });
    cartes.forEach(function (c) { if (resultats.indexOf(c) < 0) c.el.hidden = true; });

    var n = nbActifs();
    var total = cartes.length;
    if (noeudCompte) noeudCompte.textContent = resultats.length === total ? pluriel(total, 'produit') : resultats.length + ' sur ' + total + ' produits';
    if (noeudSuiteCompte) {
      if (montrees < resultats.length) noeudSuiteCompte.textContent = montrees + ' sur ' + resultats.length + ' produits affichés';
      else if (n) noeudSuiteCompte.textContent = resultats.length > 1 ? resultats.length + ' produits correspondent à ces filtres' : '1 produit correspond à ces filtres';
      else noeudSuiteCompte.textContent = pluriel(montrees, 'produit') + (montrees > 1 ? ' affichés' : ' affiché');
    }
    if (boutonSuivants) boutonSuivants.hidden = montrees >= resultats.length;
    qa('[data-dlcb-effacer]', noeudSuite).forEach(function (b) { b.hidden = !n; });
    if (noeudVide) noeudVide.hidden = resultats.length > 0;
    if (grille) grille.hidden = resultats.length === 0;
    if (noeudSuite) noeudSuite.hidden = resultats.length === 0;

    if (libelleFiltre) libelleFiltre.textContent = n ? 'Filtrer (' + n + ')' : 'Filtrer';
    if (boutonAppliquer) boutonAppliquer.textContent = resultats.length === 1 ? 'Voir 1 produit' : 'Voir ' + resultats.length + ' produits';

    boutonsIntention.forEach(function (b) {
      var cle = b.getAttribute('data-dlcb-intention');
      var actif = cle ? etat.intentions.indexOf(cle) > -1 : etat.intentions.length === 0;
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
      if (cle) {
        var possible = compteOption('intention', cle) > 0;
        if (possible || actif) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
      }
    });

    casesFiltre.forEach(function (input) {
      var groupe = input.getAttribute('data-dlcb-filtre');
      var valeur = input.value;
      var coche = groupe === 'stock' ? etat.stock : etat[groupe === 'intention' ? 'intentions' : groupe].indexOf(valeur) > -1;
      input.checked = coche;
      var nb = compteOption(groupe, valeur);
      var cpt = q('[data-dlcb-compte-option]', input.parentNode);
      if (cpt) cpt.textContent = nb;
      input.parentNode.classList.toggle('dlcb-option--indisponible', nb === 0 && !coche);
      input.disabled = nb === 0 && !coche;
    });

    rendreActifs();
    if (!sansUrl) ecrireUrl();
    memoriser();
  }

  function rendreActifs() {
    if (!noeudActifs || !listeActifs) return;
    listeActifs.innerHTML = '';
    var puces = [];
    [['intentions', 'intention'], ['pierres', 'pierres'], ['construction', 'construction'], ['budget', 'budget']].forEach(function (paire) {
      var cle = paire[0], groupe = paire[1];
      etat[cle].forEach(function (valeur) {
        var input = casesFiltre.filter(function (i) { return i.getAttribute('data-dlcb-filtre') === groupe && i.value === valeur; })[0];
        puces.push([input ? input.getAttribute('data-label') : valeur, function () { etat[cle] = etat[cle].filter(function (x) { return x !== valeur; }); }]);
      });
    });
    if (etat.stock) puces.push(['En stock', function () { etat.stock = false; }]);
    noeudActifs.hidden = !puces.length;
    puces.forEach(function (p) {
      var bt = document.createElement('button');
      bt.type = 'button';
      bt.className = 'dlcb-puce dlcb-puce--actif';
      bt.setAttribute('aria-label', 'Retirer le filtre ' + p[0]);
      bt.innerHTML = '';
      bt.appendChild(document.createTextNode(p[0] + ' '));
      var x = document.createElement('span'); x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
      bt.appendChild(x);
      bt.addEventListener('click', function () { p[1](); etat.visibles = cfg.parPage; appliquer(); });
      listeActifs.appendChild(bt);
    });
  }

  function toutEffacer() {
    etat.intentions = []; etat.pierres = []; etat.construction = []; etat.budget = []; etat.stock = false;
    etat.visibles = cfg.parPage;
    appliquer();
  }

  // ------------------------------------------------------------------ URL
  function ecrireUrl() {
    var p = new URLSearchParams(window.location.search);
    ['intention', 'pierre', 'construction', 'budget', 'stock', 'tri'].forEach(function (k) { p.delete(k); });
    if (etat.intentions.length) p.set('intention', etat.intentions.join(','));
    if (etat.pierres.length) p.set('pierre', etat.pierres.join(','));
    if (etat.construction.length) p.set('construction', etat.construction.join(','));
    if (etat.budget.length) p.set('budget', etat.budget.join(','));
    if (etat.stock) p.set('stock', '1');
    if (etat.tri !== 'preferes') p.set('tri', etat.tri);
    var chaine = p.toString();
    var url = window.location.pathname + (chaine ? '?' + chaine : '') + window.location.hash;
    try { window.history.replaceState(window.history.state, '', url); } catch (e) { /* navigateur restrictif */ }
  }
  function lireUrl() {
    var p = new URLSearchParams(window.location.search);
    var liste = function (k) { return (p.get(k) || '').split(',').filter(Boolean); };
    var valeurs = function (groupe) { return casesFiltre.filter(function (c) { return c.getAttribute('data-dlcb-filtre') === groupe; }).map(function (c) { return c.value; }); };
    etat.intentions = liste('intention').filter(function (v) { return valeurs('intention').indexOf(v) > -1; });
    etat.pierres = liste('pierre').filter(function (v) { return valeurs('pierres').indexOf(v) > -1; });
    etat.construction = liste('construction').filter(function (v) { return valeurs('construction').indexOf(v) > -1; });
    etat.budget = liste('budget').filter(function (v) { return BANDES[v]; });
    etat.stock = p.get('stock') === '1';
    var tri = p.get('tri') || 'preferes';
    etat.tri = ['preferes', 'prix-asc', 'prix-desc', 'nouveautes'].indexOf(tri) > -1 ? tri : 'preferes';
    if (selectTri) selectTri.value = etat.tri;
  }

  // ------------------------------------------------------------------ position au retour
  var CLE_MEMOIRE = 'dlcb:' + (cfg.cle || window.location.pathname);
  var rafMemoire = 0;
  function memoriser() {
    if (rafMemoire) return;
    rafMemoire = window.requestAnimationFrame(function () {
      rafMemoire = 0;
      try {
        window.sessionStorage.setItem(CLE_MEMOIRE, JSON.stringify({ recherche: window.location.search, visibles: etat.visibles, y: window.scrollY }));
      } catch (e) { /* stockage indisponible */ }
    });
  }
  function restaurer() {
    var nav = null;
    try { nav = window.performance.getEntriesByType('navigation')[0]; } catch (e) { nav = null; }
    var type = nav ? nav.type : '';
    if (type !== 'back_forward' && type !== 'reload') return false;
    var memo = null;
    try { memo = JSON.parse(window.sessionStorage.getItem(CLE_MEMOIRE)); } catch (e) { memo = null; }
    if (!memo || memo.recherche !== window.location.search) return false;
    try { window.history.scrollRestoration = 'manual'; } catch (e) { /* ignoré */ }
    etat.visibles = Math.max(cfg.parPage, +memo.visibles || 0);
    appliquer(true);
    window.requestAnimationFrame(function () { window.scrollTo(0, +memo.y || 0); });
    return true;
  }

  // ------------------------------------------------------------------ panneaux
  var declencheurCourant = null;
  function ouvrir(dialog, declencheur) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    declencheurCourant = declencheur || document.activeElement;
    html.classList.add('dlcb-verrou');
    dialog.showModal();
    var corps = q('.dlcb-panneau__corps', dialog);
    if (corps) corps.scrollTop = 0;
  }
  function brancherDialog(dialog, apresFermeture) {
    if (!dialog) return;
    dialog.addEventListener('close', function () {
      html.classList.remove('dlcb-verrou');
      if (apresFermeture) apresFermeture();
      var d = declencheurCourant;
      declencheurCourant = null;
      if (d && typeof d.focus === 'function' && document.body.contains(d)) d.focus();
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    qa('[data-dlcb-fermer]', dialog).forEach(function (b) { b.addEventListener('click', function () { dialog.close(); }); });
  }
  brancherDialog(dialogFiltres, function () { if (boutonFiltres) boutonFiltres.setAttribute('aria-expanded', 'false'); });
  brancherDialog(dialogChoix);

  if (boutonFiltres) boutonFiltres.addEventListener('click', function () {
    boutonFiltres.setAttribute('aria-expanded', 'true');
    ouvrir(dialogFiltres, boutonFiltres);
  });

  // ------------------------------------------------------------------ choix du diamètre
  var choix = { carte: null, variante: null };
  var cImg = q('[data-dlcb-choix-img]');
  var cNom = q('[data-dlcb-choix-nom]');
  var cConstruction = q('[data-dlcb-choix-construction]');
  var cPrix = q('[data-dlcb-choix-prix]');
  var cPrixMeta = q('[data-dlcb-choix-prix-meta]');
  var cBudget = q('[data-dlcb-choix-budget]');
  var cFiche = q('[data-dlcb-choix-fiche]');
  var cListe = q('[data-dlcb-choix-liste]');
  var cAide = q('[data-dlcb-choix-aide]');
  var cErreur = q('[data-dlcb-choix-erreur]');
  var cAjouter = q('[data-dlcb-choix-ajouter]');

  var LIBELLE_CONSTRUCTION = { coulissant: 'Cordon à nœud coulissant, ajustable', elastique: 'Monté sur fil élastique', inconnu: '' };
  var AIDE_CONSTRUCTION = {
    coulissant: 'Ces mesures correspondent au diamètre des perles, pas au tour de poignet. Le bracelet s’ajuste grâce à son cordon coulissant.',
    elastique: 'Ces mesures correspondent au diamètre des perles, pas au tour de poignet. Le bracelet est monté sur fil élastique : il s’enfile sans réglage.',
    inconnu: 'Ces mesures correspondent au diamètre des perles, pas au tour de poignet.'
  };

  function prixDepart(vs) {
    if (!vs.length) return '';
    var mini = vs.reduce(function (a, v) { return v.prix < a.prix ? v : a; });
    var meme = vs.every(function (v) { return v.prix === mini.prix; });
    return meme ? mini.prixTxt : 'Dès ' + mini.prixTxt;
  }

  function ouvrirChoix(carte, declencheur) {
    choix.carte = carte;
    choix.variante = null;
    var sousBudget = etat.budget.length > 0;
    var vs = sousBudget ? variantesBudget(carte) : carte.variantes;
    if (sousBudget && !vs.length) vs = carte.variantes;

    if (cImg) { cImg.src = carte.img; cImg.alt = carte.imgAlt; }
    if (cNom) cNom.textContent = carte.nom;
    if (cConstruction) cConstruction.textContent = LIBELLE_CONSTRUCTION[carte.construction] || '';
    if (cPrix) cPrix.textContent = prixDepart(vs);
    if (cPrixMeta) cPrixMeta.textContent = 'Selon le diamètre';
    if (cBudget) cBudget.hidden = !(sousBudget && vs.length < carte.variantes.length);
    if (cFiche) cFiche.href = carte.url;
    if (cAide) cAide.textContent = AIDE_CONSTRUCTION[carte.construction] || AIDE_CONSTRUCTION.inconnu;
    if (cErreur) { cErreur.hidden = true; cErreur.textContent = ''; }
    if (cAjouter) { cAjouter.disabled = true; cAjouter.textContent = 'Choisissez un diamètre'; cAjouter.removeAttribute('aria-busy'); }

    cListe.innerHTML = '';
    vs.forEach(function (v) {
      var ligne = document.createElement('button');
      ligne.type = 'button';
      ligne.className = 'dlcb-choix__ligne';
      ligne.setAttribute('role', 'radio');
      ligne.setAttribute('aria-checked', 'false');
      if (!v.dispo) ligne.disabled = true;
      var taille = Math.max(12, Math.min(40, (v.mm || 6) * 4));
      var perle = document.createElement('span');
      perle.className = 'dlcb-perle dlcb-perle--' + carte.teinte;
      perle.setAttribute('aria-hidden', 'true');
      perle.style.width = taille + 'px'; perle.style.height = taille + 'px';
      var col = document.createElement('span'); col.className = 'dlcb-choix__colonne';
      var mm = document.createElement('span'); mm.className = 'dlcb-choix__mm'; mm.textContent = v.label || 'Taille unique';
      var qual = document.createElement('span'); qual.className = 'dlcb-choix__qual'; qual.textContent = v.qual || '';
      if (sousBudget && v.dispo && dansBudget(v.prix)) {
        var puce = document.createElement('span'); puce.className = 'dlcb-choix__budget-puce'; puce.textContent = 'Dans votre budget';
        qual.appendChild(puce);
      }
      col.appendChild(mm); col.appendChild(qual);
      var prix = document.createElement('span'); prix.className = 'dlcb-choix__ligne-prix'; prix.textContent = v.prixTxt;
      var etatL = document.createElement('span'); etatL.className = 'dlcb-choix__etat'; etatL.textContent = v.dispo ? 'Choisir' : 'Épuisé';
      ligne.appendChild(perle); ligne.appendChild(col); ligne.appendChild(prix); ligne.appendChild(etatL);
      ligne.addEventListener('click', function () { selectionner(v, ligne); });
      cListe.appendChild(ligne);
    });
    ouvrir(dialogChoix, declencheur);
  }

  function selectionner(v, ligne) {
    if (!v.dispo) return;
    choix.variante = v;
    qa('.dlcb-choix__ligne', cListe).forEach(function (l) {
      var on = l === ligne;
      l.setAttribute('aria-checked', on ? 'true' : 'false');
      var e = q('.dlcb-choix__etat', l);
      if (e && !l.disabled) e.textContent = on ? 'Sélectionné' : 'Choisir';
    });
    if (cImg) { cImg.src = v.img || choix.carte.img; cImg.alt = v.imgAlt || choix.carte.imgAlt; }
    if (cPrix) cPrix.textContent = v.prixTxt;
    if (cPrixMeta) cPrixMeta.textContent = v.label ? 'Diamètre ' + v.label : '';
    if (cErreur) cErreur.hidden = true;
    if (cAjouter) { cAjouter.disabled = false; cAjouter.textContent = v.label ? 'Ajouter au panier — ' + v.label : 'Ajouter au panier'; }
  }

  if (cAjouter) cAjouter.addEventListener('click', function () {
    if (!choix.carte || !choix.variante) return;
    ajouterPanier(choix.carte, choix.variante, cAjouter, true);
  });

  // ------------------------------------------------------------------ panier
  var enCours = false;
  function majBulle(sections) {
    var contenu = sections && sections['cart-icon-bubble'];
    var bulle = document.getElementById('cart-icon-bubble');
    if (!contenu || !bulle) return;
    var doc = new DOMParser().parseFromString(contenu, 'text/html');
    var neuf = doc.getElementById('shopify-section-cart-icon-bubble') || doc.body;
    bulle.innerHTML = neuf.innerHTML;
  }

  function ajouterPanier(carte, variante, bouton, depuisChoix) {
    if (enCours || !variante || !variante.dispo) return;
    enCours = true;
    var libelleAvant = bouton.innerHTML;
    bouton.setAttribute('aria-busy', 'true');
    bouton.innerHTML = '<span class="dlcb-spin" aria-hidden="true"></span>Ajout en cours…';
    if (cErreur && depuisChoix) cErreur.hidden = true;

    var url = (cfg.cartAdd || '/cart/add') + '.js';
    var corps = { items: [{ id: variante.id, quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname };
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corps)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, statut: r.status, corps: j }; });
    }).then(function (rep) {
      enCours = false;
      bouton.removeAttribute('aria-busy');
      bouton.innerHTML = libelleAvant;
      if (!rep.ok) {
        var message = (rep.corps && (rep.corps.description || rep.corps.message)) || 'L’ajout au panier n’a pas abouti. Réessayez dans un instant.';
        if (rep.statut === 422) { variante.dispo = false; }
        erreurAjout(message, depuisChoix);
        return;
      }
      majBulle(rep.corps && rep.corps.sections);
      var meta = carte.nom + (variante.label ? ' — Diamètre ' + variante.label : '') + ' · ' + variante.prixTxt;
      if (depuisChoix && dialogChoix && dialogChoix.open) dialogChoix.close();
      try { document.dispatchEvent(new CustomEvent('dlcb:ajout', { detail: { variant: variante.id, product: carte.url } })); } catch (e) { /* ancien navigateur */ }
      // Si le tiroir panier du thème (application « slide cart ») s'ouvre de
      // lui-même sur l'ajout, il tient lieu de confirmation : pas de second
      // message par-dessus. Sinon, la confirmation de la maquette prend le relais.
      window.setTimeout(function () { if (!tiroirOuvert()) toast(meta); }, 450);
    }).catch(function () {
      enCours = false;
      bouton.removeAttribute('aria-busy');
      bouton.innerHTML = libelleAvant;
      erreurAjout('L’ajout au panier n’a pas abouti. Vérifiez votre connexion et réessayez.', depuisChoix);
    });
  }

  function erreurAjout(message, depuisChoix) {
    if (depuisChoix && cErreur) {
      cErreur.textContent = message;
      cErreur.hidden = false;
      if (choix.variante && !choix.variante.dispo) {
        qa('.dlcb-choix__ligne[aria-checked="true"]', cListe).forEach(function (l) {
          l.disabled = true; l.setAttribute('aria-checked', 'false');
          var e = q('.dlcb-choix__etat', l); if (e) e.textContent = 'Épuisé';
        });
        choix.variante = null;
        if (cAjouter) { cAjouter.disabled = true; cAjouter.textContent = 'Choisissez un autre diamètre'; }
      }
      return;
    }
    toast(message, true);
  }

  // ------------------------------------------------------------------ confirmation
  function tiroirOuvert() {
    var h = html.className || '';
    if (/open-drawer|drawer-open|cart-open|cart--open/.test(h)) return true;
    var tiroir = document.querySelector('cart-drawer.active, cart-drawer.animate, .drawer.active, [class*="slide-cart"].active, [class*="slide-cart"][open]');
    return !!tiroir;
  }
  var minuterieToast = 0;
  function toast(meta, erreur) {
    if (!zoneToast) return;
    var boite = q('.dlcb-toast', zoneToast);
    var titre = q('.dlcb-toast__titre', zoneToast);
    var metaEl = q('[data-dlcb-toast-meta]', zoneToast);
    var voir = q('.dlcb-toast__voir', zoneToast);
    if (titre) titre.textContent = erreur ? 'Ajout impossible' : 'Ajouté à votre panier';
    if (metaEl) metaEl.textContent = meta;
    if (voir) voir.hidden = !!erreur;
    if (boite) boite.setAttribute('role', erreur ? 'alert' : 'status');
    zoneToast.hidden = false;
    html.classList.add('dlcb-toast-ouvert');
    window.clearTimeout(minuterieToast);
    minuterieToast = window.setTimeout(fermerToast, erreur ? 12000 : 9000);
  }
  function fermerToast() {
    if (!zoneToast) return;
    zoneToast.hidden = true;
    html.classList.remove('dlcb-toast-ouvert');
    window.clearTimeout(minuterieToast);
  }
  qa('[data-dlcb-toast-fermer]').forEach(function (b) { b.addEventListener('click', fermerToast); });

  // ------------------------------------------------------------------ branchements
  boutonsIntention.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('aria-disabled') === 'true') return;
      var cle = b.getAttribute('data-dlcb-intention');
      if (!cle || etat.intentions.indexOf(cle) > -1) etat.intentions = [];
      else etat.intentions = [cle];
      etat.visibles = cfg.parPage;
      appliquer();
    });
  });
  casesFiltre.forEach(function (input) {
    input.addEventListener('change', function () {
      var groupe = input.getAttribute('data-dlcb-filtre');
      var cle = groupe === 'intention' ? 'intentions' : groupe;
      if (groupe === 'stock') etat.stock = input.checked;
      else if (input.checked) { if (etat[cle].indexOf(input.value) < 0) etat[cle].push(input.value); }
      else etat[cle] = etat[cle].filter(function (x) { return x !== input.value; });
      etat.visibles = cfg.parPage;
      appliquer();
    });
  });
  if (selectTri) selectTri.addEventListener('change', function () { etat.tri = selectTri.value; appliquer(); });
  qa('[data-dlcb-effacer]').forEach(function (b) { b.addEventListener('click', toutEffacer); });
  if (boutonSuivants) boutonSuivants.addEventListener('click', function () {
    var premiereNouvelle = etat.visibles;
    etat.visibles += cfg.parPage;
    appliquer();
    var visibles = qa('[data-dlcb-carte]:not([hidden])', grille);
    var cible = visibles[premiereNouvelle];
    var lien = cible && q('a', cible);
    if (lien) { try { lien.focus({ preventScroll: true }); } catch (e) { lien.focus(); } }
  });
  cartes.forEach(function (c) {
    var choisir = q('[data-dlcb-choisir]', c.el);
    if (choisir) choisir.addEventListener('click', function () { ouvrirChoix(c, choisir); });
    var direct = q('[data-dlcb-ajouter]', c.el);
    if (direct) direct.addEventListener('click', function () {
      var v = c.variantes[0];
      if (!v) return;
      ajouterPanier(c, v, direct, false);
    });
    qa('[data-dlcb-lien]', c.el).forEach(function (a) { a.addEventListener('click', memoriser); });
  });
  window.addEventListener('scroll', memoriser, { passive: true });
  window.addEventListener('pagehide', memoriser);

  // ------------------------------------------------------------------ départ
  lireUrl();
  if (!restaurer()) appliquer(true);
})();
